<script setup lang="ts">
const jwt = computed(() => localStorage.getItem('jwt') || '')
</script>

<template>
  <div>
    <iframe class="h-screen w-full" :src="`https://spectacular-chaja-c26e24.netlify.app/?token=${jwt}`" />
  </div>
</template>
